import React from 'react'

export default function ActorIcon({ actor }) {
  const nameInitials = actor.first_name[0] + actor.last_name[0]

  return <span className='actor-icon-initials'>{nameInitials}</span>
}
